<planning-top-nav></planning-top-nav>

<div class="calendar-shell">
  <header class="calendar-topbar">
    <div class="title">Calendar</div>

    <div class="controls">
      <button class="nav-btn" (click)="prevMonth()">‹</button>

      <div class="selects">
        <select class="select" [(ngModel)]="selectedMonthIndex" (change)="onMonthJump()">
          <option *ngFor="let m of monthNames; let idx = index" [ngValue]="idx">
            {{ m }}
          </option>
        </select>

        <select class="select" [(ngModel)]="selectedYear" (change)="onYearChange()">
          <option *ngFor="let y of yearOptions" [ngValue]="y">{{ y }}</option>
        </select>
      </div>

      <button class="nav-btn" (click)="nextMonth()">›</button>
    </div>
  </header>

  <main class="month-page">
    <div class="month-card">
      <div class="month-header">
        <div class="month-title">
          <span class="month-name">{{ view.label }}</span>
          <span class="month-year">{{ view.year }}</span>
        </div>
      </div>

      <div class="dow">
        <div class="wk-col">Wk</div>
        <div class="dow-item" *ngFor="let d of weekDayShort">{{ d }}</div>
      </div>

      <div class="grid">
        <div class="week-row" *ngFor="let row of view.weeks">
          <div class="wk-num">{{ row.weekNumber }}</div>

          <div
            class="day"
            *ngFor="let day of row.days"
            [class.outside]="!day.inMonth"
            [class.today]="day.isToday"
          >
            <span class="num">{{ formatDayNumber(day.date) }}</span>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
